import script from "./RewardDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./RewardDetails.vue?vue&type=script&setup=true&lang=js"

import "./RewardDetails.vue?vue&type=style&index=0&id=5c7e0fc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c7e0fc8"]])

export default __exports__